<footer class="app-footer">

  <!-- Left: copyright -->
  <div class="footer-brand">
    <span class="footer-copy">&copy; {{ year }} SignaTech. All rights reserved.</span>
  </div>

  <!-- Centre: status -->
  <div class="footer-status">
    <span class="status-dot"></span>
    <span class="status-text">All systems operational</span>
  </div>

  <!-- Right: links + version -->
  <div class="footer-right">
    <a href="#" class="footer-link">Privacy Policy</a>
    <span class="footer-sep"></span>
    <a href="#" class="footer-link">Support</a>
    <span class="footer-sep"></span>
    <a href="#" class="footer-link">Docs</a>
    <span class="footer-version">v1.0.0</span>
  </div>

</footer>
